import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState, UserTokensState, UserDataState } from "../../redux/types";

const initialState: UserState = {
  user: {
    id: 0,
    email: "",
    firstName: "",
    lastName: "",
    subscriptionCode: "",
    country: "",
    locale: "",
    phone: "",
    organizationId: null,
    isAdmin: false,
    isOrganizationManager: false,
  },
  tokens: {
    access: "",
    refresh: "",
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUser: (state, action: PayloadAction<UserState>) => {
      return action.payload;
    },
    saveUserInfo: (state, action: PayloadAction<UserDataState>) => {
      return { ...state, user: action.payload };
    },
    updateTokens: (state, action: PayloadAction<UserTokensState>) => {
      return { ...state, tokens: action.payload };
    },
    removeUser: () => {
      return initialState;
    },
    default: (state) => {
      return state;
    },
  },
});

export const { saveUser, removeUser, updateTokens, saveUserInfo } =
  userSlice.actions;
export default userSlice.reducer;
